import React from "react";
import { Link } from "react-router-dom";

const T = "#00c896";
const N = "#0f2040";
const F = "system-ui,sans-serif";

// ── Illustrations ─────────────────────────────────────────────────────────────

const IllustFaceEngine = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="320" height="180" fill="#f0fdf9" rx="12"/>
    {/* Face scan */}
    <circle cx="120" cy="90" r="58" fill="white" stroke={T} strokeWidth="1.5" strokeDasharray="6 3"/>
    <circle cx="120" cy="90" r="44" stroke={T} strokeWidth="1" opacity="0.35"/>
    <ellipse cx="120" cy="84" rx="24" ry="28" stroke="#d1d5db" strokeWidth="1.5" fill="#fafafa"/>
    <circle cx="110" cy="78" r="3" fill="#374151"/><circle cx="130" cy="78" r="3" fill="#374151"/>
    <path d="M113 96 q7 5 14 0" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    {/* Scan line */}
    <line x1="62" y1="90" x2="178" y2="90" stroke={T} strokeWidth="1" opacity="0.5" strokeDasharray="3 2"/>
    {/* Corner brackets */}
    {([[48,32],[192,32],[48,148],[192,148]] as [number,number][]).map(([cx,cy],i) => (
      <g key={i}>
        <line x1={cx} y1={cy} x2={cx+(i%2===0?10:-10)} y2={cy} stroke={T} strokeWidth="2" strokeLinecap="round"/>
        <line x1={cx} y1={cy} x2={cx} y2={cy+(i<2?10:-10)} stroke={T} strokeWidth="2" strokeLinecap="round"/>
      </g>
    ))}
    {/* Landmarks */}
    {[[120,56],[98,72],[142,72],[120,110],[108,98],[132,98]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="2" fill={T} opacity="0.6"/>
    ))}
    {/* Liveness badge */}
    <rect x="186" y="40" width="120" height="36" rx="8" fill={N}/>
    <circle cx="202" cy="58" r="6" fill={T}/>
    <path d="M199 58l2 2 4-4" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="213" y="55" fontSize="9" fontWeight="700" fill="white" fontFamily={F}>LIVENESS OK</text>
    <text x="213" y="67" fontSize="7.5" fill="rgba(255,255,255,0.55)" fontFamily={F}>3D Anti-Spoofing</text>
    {/* Match score */}
    <rect x="186" y="84" width="120" height="36" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="213" y="99" fontSize="8" fill="#9ca3af" fontFamily={F}>Match Score</text>
    <text x="213" y="113" fontSize="15" fontWeight="800" fill={T} fontFamily={F}>99.2%</text>
    {/* Popular badge */}
    <rect x="186" y="128" width="60" height="18" rx="9" fill={T}/>
    <text x="216" y="140" fontSize="8" fontWeight="700" fill="white" textAnchor="middle" fontFamily={F}>★ Popular</text>
    {/* Response */}
    <rect x="252" y="128" width="54" height="18" rx="9" fill="rgba(15,32,64,0.08)"/>
    <text x="279" y="140" fontSize="7.5" fill={N} textAnchor="middle" fontFamily={F}>{"< 2s"}</text>
  </svg>
);

const IllustWatchlist = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="320" height="180" fill="#fff7f0" rx="12"/>
    {/* Radar */}
    <circle cx="110" cy="95" r="70" stroke="#f97316" strokeWidth="0.5" opacity="0.25" fill="none"/>
    <circle cx="110" cy="95" r="50" stroke="#f97316" strokeWidth="0.5" opacity="0.35" fill="none"/>
    <circle cx="110" cy="95" r="30" stroke="#f97316" strokeWidth="0.8" opacity="0.5" fill="none"/>
    <circle cx="110" cy="95" r="12" fill="#fef3c7" stroke="#f97316" strokeWidth="1.5"/>
    <text x="110" y="99" fontSize="8.5" fontWeight="700" fill="#f97316" textAnchor="middle" fontFamily={F}>AML</text>
    <path d="M110 95 L110 25 A70 70 0 0 1 176 135 Z" fill={T} opacity="0.06"/>
    {/* Nodes */}
    <circle cx="60" cy="55" r="10" fill="#fee2e2" stroke="#ef4444" strokeWidth="1.5"/>
    <text x="60" y="59" fontSize="7" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>PEP</text>
    <circle cx="168" cy="60" r="10" fill="#fee2e2" stroke="#ef4444" strokeWidth="1.5"/>
    <text x="168" y="64" fontSize="7" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>SDN</text>
    <circle cx="145" cy="152" r="10" fill="#fef3c7" stroke="#f59e0b" strokeWidth="1.5"/>
    <text x="145" y="156" fontSize="6.5" fontWeight="700" fill="#f59e0b" textAnchor="middle" fontFamily={F}>WL</text>
    <line x1="110" y1="95" x2="60" y2="55" stroke="#ef4444" strokeWidth="1" strokeDasharray="3 2" opacity="0.6"/>
    <line x1="110" y1="95" x2="168" y2="60" stroke="#ef4444" strokeWidth="1" strokeDasharray="3 2" opacity="0.6"/>
    <line x1="110" y1="95" x2="145" y2="152" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3 2" opacity="0.6"/>
    {/* Result panel */}
    <rect x="202" y="20" width="104" height="140" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="254" y="40" fontSize="9" fontWeight="700" fill={N} textAnchor="middle" fontFamily={F}>Screening</text>
    {[
      { label:"PEP Match", val:"2 hits", color:"#ef4444" },
      { label:"Sanctions",  val:"1 hit",  color:"#ef4444" },
      { label:"Neg. Info",  val:"Clear",  color:T },
      { label:"Watchlist",  val:"Clear",  color:T },
    ].map((r,i) => (
      <g key={i}>
        <text x="214" y={60+i*26} fontSize="7" fill="#9ca3af" fontFamily={F}>{r.label}</text>
        <text x="214" y={72+i*26} fontSize="9" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    <rect x="214" y="144" width="80" height="12" rx="6" fill="#fee2e2"/>
    <text x="254" y="153" fontSize="7" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ Manual Review</text>
  </svg>
);

const IllustBankStatement = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="320" height="180" fill="#f8faff" rx="12"/>
    {/* Bank statement card */}
    <rect x="20" y="20" width="170" height="140" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1.5"/>
    <rect x="20" y="20" width="170" height="32" rx="10" fill={N}/>
    <rect x="20" y="44" width="170" height="8" fill={N}/>
    <text x="105" y="38" fontSize="8" fontWeight="700" fill="white" textAnchor="middle" fontFamily={F}>BANK STATEMENT</text>
    {/* Rows */}
    {[
      { d:"01 Mar", desc:"Transfer In",   amt:"+5,000,000",  c:T },
      { d:"02 Mar", desc:"Transfer Out",  amt:"-2,500,000",  c:"#ef4444" },
      { d:"05 Mar", desc:"TOP UP",        amt:"+1,200,000",  c:T },
      { d:"07 Mar", desc:"Withdrawal",    amt:"-800,000",    c:"#ef4444" },
    ].map((r,i) => (
      <g key={i}>
        <rect x="28" y={64+i*24} width="154" height="20" rx="3" fill={i%2===0?"#f8fafc":"white"}/>
        <text x="34" y={77+i*24} fontSize="6.5" fill="#9ca3af" fontFamily={F}>{r.d}</text>
        <text x="62" y={77+i*24} fontSize="7" fill={N} fontFamily={F}>{r.desc}</text>
        <text x="168" y={77+i*24} fontSize="7" fontWeight="700" fill={r.c} textAnchor="end" fontFamily={F}>{r.amt}</text>
      </g>
    ))}
    {/* Tamper alert */}
    <rect x="28" y="156" width="70" height="1.5" fill="#ef4444" opacity="0.5"/>
    {/* Right side analysis */}
    <rect x="204" y="20" width="104" height="140" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="256" y="40" fontSize="9" fontWeight="700" fill={N} textAnchor="middle" fontFamily={F}>Analysis</text>
    {[
      { label:"Authenticity", val:"Fake ⚠", color:"#ef4444" },
      { label:"Avg Balance",  val:"Rp 3.2M",  color:N },
      { label:"Cash Flow",    val:"Stable",   color:T },
      { label:"Metadata",     val:"Mismatch", color:"#f59e0b" },
    ].map((r,i) => (
      <g key={i}>
        <text x="214" y={58+i*26} fontSize="7" fill="#9ca3af" fontFamily={F}>{r.label}</text>
        <text x="214" y={70+i*26} fontSize="9" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    <rect x="214" y="144" width="80" height="12" rx="6" fill="#fee2e2"/>
    <text x="254" y="153" fontSize="7" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ Fake Detected</text>
  </svg>
);

const IllustLegalOpinion = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="320" height="180" fill="#faf5ff" rx="12"/>
    {/* Document */}
    <rect x="20" y="18" width="140" height="144" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1.5"/>
    <rect x="20" y="18" width="140" height="28" rx="10" fill="#6366f1"/>
    <rect x="20" y="38" width="140" height="8" fill="#6366f1"/>
    <text x="90" y="34" fontSize="8" fontWeight="700" fill="white" textAnchor="middle" fontFamily={F}>KONTRAK PERJANJIAN</text>
    {/* Lines */}
    {[50,64,78,92,106,120,134].map((y,i) => (
      <rect key={i} x="32" y={y} width={i%3===0?100:i%3===1?80:110} height="7" rx="2" fill="rgba(15,32,64,0.07)"/>
    ))}
    {/* Highlight */}
    <rect x="32" y="106" width="116" height="7" rx="2" fill="rgba(239,68,68,0.15)" stroke="#ef4444" strokeWidth="0.5"/>
    {/* Risk flag */}
    <rect x="32" y="150" width="116" height="8" rx="4" fill="rgba(239,68,68,0.1)"/>
    <text x="90" y="157" fontSize="7" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ Liability Clause Detected</text>
    {/* AI output */}
    <rect x="172" y="18" width="136" height="144" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="240" y="36" fontSize="9" fontWeight="700" fill={N} textAnchor="middle" fontFamily={F}>AI Legal Opinion</text>
    <rect x="182" y="42" width="116" height="1" fill="#f3f4f6"/>
    {[
      { label:"Risk Level",    val:"Medium",    color:"#f59e0b" },
      { label:"Liability",     val:"Identified",color:"#ef4444" },
      { label:"Compliance",    val:"OJK OK",    color:T },
      { label:"Jurisdiction",  val:"Indonesia", color:N },
    ].map((r,i) => (
      <g key={i}>
        <text x="182" y={62+i*26} fontSize="7" fill="#9ca3af" fontFamily={F}>{r.label}</text>
        <text x="182" y={74+i*26} fontSize="9" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    <rect x="182" y="152" width="116" height="8" rx="4" fill="rgba(99,102,241,0.1)"/>
    <text x="240" y="159" fontSize="7" fontWeight="600" fill="#6366f1" textAnchor="middle" fontFamily={F}>Generated in 1.4s</text>
  </svg>
);

const IllustCreditEngine = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="320" height="180" fill="#f0fdf9" rx="12"/>
    {/* Gauge */}
    <path d="M60 140 A80 80 0 0 1 220 140" stroke="#e5e7eb" strokeWidth="18" fill="none" strokeLinecap="round"/>
    <path d="M60 140 A80 80 0 0 1 220 140" stroke="url(#creditGrad)" strokeWidth="18" fill="none" strokeLinecap="round" strokeDasharray="252 0"/>
    <defs>
      <linearGradient id="creditGrad" x1="60" y1="0" x2="220" y2="0">
        <stop offset="0%" stopColor="#ef4444"/>
        <stop offset="50%" stopColor="#f59e0b"/>
        <stop offset="100%" stopColor={T}/>
      </linearGradient>
    </defs>
    {/* Needle — pointing to "good" */}
    <line x1="140" y1="140" x2="206" y2="88" stroke={N} strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="140" cy="140" r="6" fill={N}/>
    <circle cx="140" cy="140" r="3" fill="white"/>
    <text x="140" y="118" fontSize="26" fontWeight="800" fill={T} textAnchor="middle" fontFamily={F}>782</text>
    <text x="140" y="132" fontSize="9" fill="#9ca3af" textAnchor="middle" fontFamily={F}>Credit Score</text>
    <text x="50" y="158" fontSize="7.5" fill="#ef4444" fontFamily={F}>Poor</text>
    <text x="130" y="164" fontSize="7.5" fill="#f59e0b" textAnchor="middle" fontFamily={F}>Fair</text>
    <text x="220" y="158" fontSize="7.5" fill={T} textAnchor="end" fontFamily={F}>Good</text>
    {/* Decision badge */}
    <rect x="212" y="20" width="96" height="100" rx="10" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="260" y="40" fontSize="8.5" fontWeight="700" fill={N} textAnchor="middle" fontFamily={F}>Decision</text>
    <rect x="224" y="46" width="72" height="24" rx="8" fill="rgba(0,200,150,0.12)" stroke={T} strokeWidth="1"/>
    <text x="260" y="62" fontSize="11" fontWeight="800" fill={T} textAnchor="middle" fontFamily={F}>APPROVED</text>
    {[
      { label:"Limit",   val:"Rp 50M" },
      { label:"Rate",    val:"0.8%/mo" },
      { label:"Tenor",   val:"24 mo" },
    ].map((d,i) => (
      <g key={i}>
        <text x="224" y={86+i*18} fontSize="6.5" fill="#9ca3af" fontFamily={F}>{d.label}</text>
        <text x="296" y={86+i*18} fontSize="8" fontWeight="700" fill={N} textAnchor="end" fontFamily={F}>{d.val}</text>
      </g>
    ))}
    {/* Data sources */}
    <rect x="20" y="20" width="180" height="44" rx="8" fill="white" stroke="#e5e7eb" strokeWidth="1"/>
    <text x="30" y="35" fontSize="7.5" fontWeight="700" fill={N} fontFamily={F}>Data Sources</text>
    {[
      {label:"BI SLIK",  color:"#6366f1", x:30},
      {label:"PPATK",    color:"#f59e0b", x:84},
      {label:"Dukcapil", color:"#0ea5e9", x:138},
    ].map((s) => (
      <g key={s.label}>
        <rect x={s.x} y={41} width={48} height={14} rx={7} fill={s.color} opacity={0.12} stroke={s.color} strokeWidth={1}/>
        <text x={s.x+24} y={51} fontSize="7" fontWeight="700" fill={s.color} textAnchor="middle" fontFamily={F}>{s.label}</text>
      </g>
    ))}
  </svg>
);

// ── Product Data ──────────────────────────────────────────────────────────────
const services = [
  {
    tag: "Popular",
    tagColor: T,
    title: "Face Engine",
    desc: "Identity checking & eKYC with biometric face match, passive liveness detection, and 3D anti-spoofing — all in a single, sub-2-second API call.",
    stats: [
      { val: "99.97%", label: "Face accuracy" },
      { val: "<2s",    label: "Response time" },
      { val: "3D",     label: "Liveness" },
    ],
    illustration: <IllustFaceEngine />,
    color: T,
  },
  {
    tag: "Compliance",
    tagColor: "#f97316",
    title: "Watchlist Screening",
    desc: "Real-time PEP, sanctions, and negative information screening against 200+ global databases including OFAC, UN, and OJK watchlists. Automated ongoing monitoring.",
    stats: [
      { val: "200+",      label: "Watchlists" },
      { val: "Real-time", label: "Updates" },
      { val: "OJK",       label: "Compliant" },
    ],
    illustration: <IllustWatchlist />,
    color: "#f97316",
  },
  {
    tag: "Fraud",
    tagColor: "#ef4444",
    title: "Bank Statement Analyzer",
    desc: "Real-time detection of fake and manipulated bank statements. Deep transaction forensics, metadata validation, and cash flow scoring — catch fraud before approval.",
    stats: [
      { val: "98%",   label: "Detection rate" },
      { val: "<1s",   label: "Analysis time" },
      { val: "Multi", label: "Bank formats" },
    ],
    illustration: <IllustBankStatement />,
    color: "#ef4444",
  },
  {
    tag: "AI-Powered",
    tagColor: "#6366f1",
    title: "Legal Opinion",
    desc: "Instant AI-powered legal insights for compliance and risk teams. Structured legal analysis on contracts, agreements, and documents in under 2 seconds.",
    stats: [
      { val: "<2s",      label: "Analysis time" },
      { val: "OJK",      label: "Framework" },
      { val: "AI + Law", label: "Hybrid model" },
    ],
    illustration: <IllustLegalOpinion />,
    color: "#6366f1",
  },
  {
    tag: "Credit",
    tagColor: "#0ea5e9",
    title: "Credit Approval Engine",
    desc: "Fast, accurate credit approval decisions powered by multi-source data (BI SLIK, PPATK, Dukcapil) and AI scoring models — available anywhere, anytime.",
    stats: [
      { val: "3+",    label: "Data sources" },
      { val: "AI",    label: "Scoring model" },
      { val: "24/7",  label: "Availability" },
    ],
    illustration: <IllustCreditEngine />,
    color: "#0ea5e9",
  },
];

// ── Component ─────────────────────────────────────────────────────────────────
const ServiceSection: React.FC = () => {
  return (
    <section style={{ background: "#f8fafc", padding: "80px 0 120px" }}>
      <div className="container">

        {/* Header */}
        <div className="svc-page-header" style={{ textAlign: "center", marginBottom: 64 }}>
          <span style={{
            display: "inline-block", padding: "6px 18px", borderRadius: 20,
            background: "rgba(0,200,150,0.1)", border: "1px solid rgba(0,200,150,0.25)",
            fontSize: 13, fontWeight: 700, color: "#00a07a", marginBottom: 16,
          }}>
            Our Products
          </span>
          <h2 style={{ fontSize: 38, fontWeight: 800, color: N, marginBottom: 16, lineHeight: 1.2 }}>
            Identity Intelligence<br />for Every Decision
          </h2>
          <p style={{ color: "rgba(15,32,64,0.55)", fontSize: 16, maxWidth: 560, margin: "0 auto" }}>
            Five composable products — from eKYC to credit decisions — built for Indonesia's regulatory landscape.
          </p>
        </div>

        {/* Grid */}
        <div className="svc-page-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(440px, 1fr))", gap: 28 }}>
          {services.map((svc, i) => (
            <div
              key={i}
              style={{
                background: "white",
                borderRadius: 16,
                border: "1px solid rgba(15,32,64,0.07)",
                boxShadow: "0 4px 24px rgba(15,32,64,0.06)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.transform = "translateY(-4px)";
                (e.currentTarget as HTMLDivElement).style.boxShadow = "0 12px 40px rgba(15,32,64,0.12)";
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)";
                (e.currentTarget as HTMLDivElement).style.boxShadow = "0 4px 24px rgba(15,32,64,0.06)";
              }}
            >
              {/* Illustration */}
              <div className="svc-illust-wrap" style={{ height: 180, overflow: "hidden", flexShrink: 0 }}>
                {svc.illustration}
              </div>

              {/* Content */}
              <div style={{ padding: "28px 28px 24px", flex: 1, display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                  <span style={{
                    padding: "3px 12px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                    background: svc.tagColor + "18", color: svc.tagColor, border: `1px solid ${svc.tagColor}30`,
                  }}>
                    {svc.tag}
                  </span>
                </div>
                <h3 style={{ fontSize: 20, fontWeight: 800, color: N, marginBottom: 10 }}>{svc.title}</h3>
                <p style={{ fontSize: 14, color: "rgba(15,32,64,0.6)", lineHeight: 1.7, marginBottom: 20, flex: 1 }}>{svc.desc}</p>

                {/* Stats */}
                <div style={{ display: "flex", gap: 24, paddingTop: 20, borderTop: "1px solid rgba(15,32,64,0.07)", marginBottom: 20 }}>
                  {svc.stats.map((s, j) => (
                    <div key={j}>
                      <div style={{ fontSize: 18, fontWeight: 800, color: svc.color }}>{s.val}</div>
                      <div style={{ fontSize: 11, color: "rgba(15,32,64,0.45)", marginTop: 2 }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <Link
                  to="/service-details"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 6,
                    fontSize: 13, fontWeight: 700, color: svc.color, textDecoration: "none",
                  }}
                >
                  View documentation
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2 7h10M8 3l4 4-4 4" stroke={svc.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: 64 }}>
          <p style={{ color: "rgba(15,32,64,0.5)", marginBottom: 24, fontSize: 15 }}>
            Need a custom integration or enterprise plan?
          </p>
          <Link to="/contact" className="thm-btn agency-btn">
            <span className="text">Talk to our team</span>
            <span className="arrow"><span className="arrow-icon">
              {[0,1].map(k => (
                <svg key={k} width="20" height="20" viewBox="0 0 28 28" fill="none">
                  <rect x="5.07" y="19.98" width="20.57" height="2.61" transform="rotate(-40.28 5.07 19.98)" fill="white"/>
                  <rect x="7.97" y="7.24" width="2.61" height="2.61" transform="rotate(-40.28 7.97 7.24)" fill="white"/>
                  <rect x="11.65" y="7.55" width="2.61" height="2.61" transform="rotate(-40.28 11.65 7.55)" fill="white"/>
                  <rect x="15.33" y="7.85" width="2.61" height="2.61" transform="rotate(-40.28 15.33 7.85)" fill="white"/>
                  <rect x="18.71" y="11.84" width="2.61" height="2.61" transform="rotate(-40.28 18.71 11.84)" fill="white"/>
                  <rect x="18.41" y="15.52" width="2.61" height="2.61" transform="rotate(-40.28 18.41 15.52)" fill="white"/>
                  <rect x="18.10" y="19.20" width="2.61" height="2.61" transform="rotate(-40.28 18.10 19.20)" fill="white"/>
                </svg>
              ))}
            </span></span>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default ServiceSection;
